const values = [2, 3, 4, 6, 8, 16, 24];
export default values.map(v => `mdl-shadow--${v}dp`);



// WEBPACK FOOTER //
// ./src/utils/shadows.js